// extracted by mini-css-extract-plugin
export default {"secondary":"secondary-HrqDF"};